import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../repeat/Header";
import Footer from "../repeat/Footer";
import GeneralData from "./DepData/generalData";
import "./style.css"; 
import Navigation from "./navigation";
import Lab1 from "../images/engile-computer.jpg";
import Lab2 from '../images/generallab2.jpg';
import Lab3 from '../images/genarallab3.jpg';
import Lab4 from '../images/genarallab4.jpeg';
import Lab5 from '../images/generallab5.jpeg';
import cse from "../home/departments/Computer Departmet.jpg";
import ece from "../home/departments/ECE Department.jpg";
import eee from "../home/departments/EEE Department.jpg";
import mech from "../home/departments/Mech Department.jpg";
import general from "../home/departments/General Department1.jpg";


const Cse = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch data from the backend
    fetch("https://gptkpm.in/backend/admin/genaral-dept-img.php")
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          setData(data);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  }, []);

  const navigate = useNavigate();
    const handleNavigation = (path) => {
      navigate(path);
    };

  return (
    <div className="cse-container">
      <Header />
      <Navigation />
      <GeneralData />

      <div className="notebook-container">
        <div className="notebook">
          <div className="page vision-page">
            <h2 className="page-title">Vision of the department: </h2>
            <p style={{ lineHeight: "30px" }}>
            The Vision of the Section is to promote excellence in Teaching and Research, inculcating a‘Spirit of Enquiry’, ‘Quest for Knowledge’ in students regarding the laws governing the nature, making them formidable in the foundations of Basic Sciences, Humanities and in the usage of English Language for ‘Effective Communication’ apart from grooming them to be Morally and Socially Responsible Professionals            </p>        
              </div>
          <div className="page mission-page">
            <h2 className="page-title">Mission of the department:</h2>
            <ul style={{ listStyle: "none", lineHeight: "40px" }}>
              <li>M1:-To Provide requisite Knowledge of Basic Sciences to Students and make them apply that in their respective domains of Engineering Education.

              </li>
              <li>M2:-To Promote ‘Holistic Learning Environment’ through ‘Inter-disciplinary’ and ‘Collaborative Learning.’


              </li>
              <li>M3:-To Impart effective English Communication, Presentation Skills apart from Life Skills that aim at over-all ‘Personality Development’ of the Student.


              </li>
              <li>M4:-To Develop ‘Sensitivity’ in the Students towards Social, Environmental and Ethical concerns/issues in Personal and Professional spheres with the ultimate aim of safeguarding them.

              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="sec-2">
        <h3 className="section-title">Staff Members/ Faculty</h3>
        {loading ? (
          <p className="loading-text">Loading...</p>
        ) : (
          <div className="staff-grid">
            {data.map((item) => (
              <div key={item.id} className="staff-card">
                <img
                  src={item.image}
                  alt="General"
                  className="staff-image"
                />
                <div className="staff-detail">
                  <h2 className="staff-name">Name: {item.name}</h2>
                  <p className="staff-profession">
                    Profession: {item.profession}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="sec-3">
        <h2>Labs</h2>
        <div id="lab">
          <div className="lab-item">
            <img src={Lab1} alt="Lab 1" />
            <p className="lab-name">COMPUTER LAB</p>
          </div>
          <div className="lab-item">
            <img src={Lab2} alt="Lab 2" />
            <p className="lab-name">PHYSICS LAB</p>
          </div>
          <div className="lab-item">
            <img src={Lab3} alt="Lab 3" />
            <p className="lab-name">CHEMISTRY LAB</p>
          </div>
          <div className="lab-item">
            <img src={Lab4} alt="Lab 4" />
            <p className="lab-name">LIFE SKILLS LAB</p>
          </div>
          <div className="lab-item">
            <img src={Lab5} alt="Lab 5" />
            <p className="lab-name">COMMUNICATION LAB</p>
          </div>
        </div>
      </div>

      <div id="part-5">
                    <div id="part-5-left">
                      <h2>Departments</h2>
                      <p>Here is a list of all the departments in the college</p>
                    </div>
                    <div id="part-5-right" className="horizontal-scroll-container">
                      <div className="img-dept">
                        <img src={cse} alt="DCME Department" />
                        <button onClick={() => handleNavigation("/cse")}>DCME</button>
                      </div>
                      <div className="img-dept">
                        <img src={ece} alt="DECE Department" />
                        <button onClick={() => handleNavigation("/Ece")}>DECE</button>
                      </div>
                      <div className="img-dept">
                        <img src={eee} alt="DEEE Department" />
                        <button onClick={() => handleNavigation("/Eee")}>DEEE</button>
                      </div>
                      <div className="img-dept">
                        <img src={mech} alt="DME Department" />
                        <button onClick={() => handleNavigation("/Mech")}>DME</button>
                      </div>
                      <div className="img-dept">
                        <img src={general} alt="General Department" />
                        <button onClick={() => handleNavigation("/General")}>General</button>
                      </div>
                    </div>
                  </div>      
      <Footer />
    </div>
  );
};

export default Cse;
